import OwnerRoyaltiesQuery from 'graphql/queries/owner-royalties';

import client from './graphql';
import decodeToken from './decode-token';

export default async function getRoyalties(token) {
  const where = { owner: { id: decodeToken(token).userId } };

  try {
    const { royaltiesConnection } = await client(token).query(OwnerRoyaltiesQuery, { where });
    return royaltiesConnection.edges.map((edge) => edge.node);
  } catch (error) {
    console.error('Failed to get royalties', error);
    return [];
  }
}
